import {PlatformMessageType} from "../platform-message-type.enum";

export interface ToastRawJsonData {
    PlatformMessagesType: PlatformMessageType.TOASTER;
    MessageDataJson: string; //apparently this contains an array of toaster messages
}

export interface ToastItemKind {
    DisplayMode: MessageDisplayMode;
    AnimationType?: MessageAnimationType;
}

export enum MessageDisplayMode {
    TOASTER = 0,
    ANIMATION = 1
}

export enum MessageAnimationType {
    BURNOUT = 4
}

export enum FIREBASE_TOAST_TYPES {
    TIMED = 'timed_toaster',
    ACKNOWLEDGE = 'acknowledge_toaster',
    ACTION = 'action_toaster'
}

export interface ToastRawDataItem extends ToastItemKind {
    Type?: FIREBASE_TOAST_TYPES;
    MessageID: string | number;
    GameTypeID?: string | number;
    Title: string;
    SubTitle: string;
    DurationInSec: number;
    MobileImage: string;
    PCImage: string;
    IconImagePath?: string;
    customUIConfig?: string;
    ResponseTopicPath: string;
    MetaDataParams?: string | null;
    analyticsData?: {
        category: string;
        action: string;
        label?: string;
    };
    LangIso3: string;
    close?: boolean;
    buttonText?: string;
    callback?: () => void;
    layout?: number;
}
